/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesCatalogServer = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var ServicesCatalogServer = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        Bulk: function () {
            return function (headers) {
                var service = {
                    get: function (bulkRequest) { return httpClient.invoke('POST', '/bulk', bulkRequest, headers); },
                };
                service.get.__http_method = 'POST';
                service.get.__http_url = '/bulk';
                return service;
            };
        },
        BusinessCatalog: function () {
            return function (headers) {
                var service = {
                    get: function (getBusinessRequest) { return httpClient.invoke('GET', '/v1/business', getBusinessRequest, headers); },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/v1/business';
                return service;
            };
        },
        CategoriesCatalog: function () {
            return function (headers) {
                var service = {
                    get: function (getCategoryRequest) { return httpClient.invoke('GET', '/categories/{id}', getCategoryRequest, headers); },
                    list: function (listCategoriesRequest) { return httpClient.invoke('GET', '/categories', listCategoriesRequest, headers); },
                    query: function (queryCategoriesRequest) { return httpClient.invoke('POST', '/categories', queryCategoriesRequest, headers); },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/categories/{id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/categories';
                service.query.__http_method = 'POST';
                service.query.__http_url = '/categories';
                return service;
            };
        },
        CouponsAdapter: function () {
            return function (headers) {
                var service = {
                    getItemsForCouponsByFilters: function (getItemsForCouponsByFiltersRequest) {
                        return httpClient.invoke('GET', '/api/v2/items-for-coupons-by-filters', getItemsForCouponsByFiltersRequest, headers);
                    },
                    getItemsForCouponsByIds: function (getItemsForCouponsByIdsRequest) {
                        return httpClient.invoke('GET', '/api/v2/items-for-coupons-by-ids', getItemsForCouponsByIdsRequest, headers);
                    },
                    getItemsForShoutout: function (getItemsForShoutoutRequest) {
                        return httpClient.invoke('GET', '/api/v2/items-for-shoutout', getItemsForShoutoutRequest, headers);
                    },
                };
                service.getItemsForCouponsByFilters.__http_method = 'GET';
                service.getItemsForCouponsByFilters.__http_url = '/api/v2/items-for-coupons-by-filters';
                service.getItemsForCouponsByIds.__http_method = 'GET';
                service.getItemsForCouponsByIds.__http_url = '/api/v2/items-for-coupons-by-ids';
                service.getItemsForShoutout.__http_method = 'GET';
                service.getItemsForShoutout.__http_url = '/api/v2/items-for-shoutout';
                return service;
            };
        },
        ResourcesCatalog: function () {
            return function (headers) {
                var service = {
                    get: function (getResourceRequest) { return httpClient.invoke('GET', '/resources/{id}', getResourceRequest, headers); },
                    list: function (listResourcesRequest) { return httpClient.invoke('GET', '/resources', listResourcesRequest, headers); },
                    query: function (queryResourcesRequest) { return httpClient.invoke('POST', '/resources', queryResourcesRequest, headers); },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/resources/{id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/resources';
                service.query.__http_method = 'POST';
                service.query.__http_url = '/resources';
                return service;
            };
        },
        ServicesCatalog: function () {
            return function (headers) {
                var service = {
                    get: function (getServiceRequest) { return httpClient.invoke('GET', '/v1/catalog/services/{id}', getServiceRequest, headers); },
                    list: function (listServicesRequest) { return httpClient.invoke('GET', '/v1/catalog/services', listServicesRequest, headers); },
                    listByCategorySlug: function (listServicesBySlugRequest) {
                        return httpClient.invoke('GET', '/services/byCategorySlug/{slug}', listServicesBySlugRequest, headers);
                    },
                    listByResourceSlug: function (listServicesBySlugRequest) {
                        return httpClient.invoke('GET', '/services/byResourceSlug/{slug}', listServicesBySlugRequest, headers);
                    },
                    query: function (queryServicesRequest) {
                        return httpClient.invoke('POST', '/v1/catalog/services/query', queryServicesRequest, headers);
                    },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/v1/catalog/services/{id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/v1/catalog/services';
                service.listByCategorySlug.__http_method = 'GET';
                service.listByCategorySlug.__http_url = '/services/byCategorySlug/{slug}';
                service.listByResourceSlug.__http_method = 'GET';
                service.listByResourceSlug.__http_url = '/services/byResourceSlug/{slug}';
                service.query.__http_method = 'POST';
                service.query.__http_url = '/v1/catalog/services/query';
                return service;
            };
        },
        TpaSiteStructureService: function () {
            return function (headers) {
                var service = {
                    getTpaSiteStructure: function (tpaSiteStructureRequest) {
                        return httpClient.invoke('POST', '/v1/site-structure', tpaSiteStructureRequest, headers);
                    },
                };
                service.getTpaSiteStructure.__http_method = 'POST';
                service.getTpaSiteStructure.__http_url = '/v1/site-structure';
                return service;
            };
        },
    };
};
exports.ServicesCatalogServer = ServicesCatalogServer;
exports.ServicesCatalogServer.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map